import { render, staticRenderFns } from "./TableMenu.vue?vue&type=template&id=447d7aca&"
import script from "./TableMenu.vue?vue&type=script&lang=ts&"
export * from "./TableMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports